<template>
  <div
    class="tree-select"
    :style="innerWidth ? 'width:' + innerWidth + 'px;' : ''"
  >
    <el-select
      class="zwx-select"
      :class="{ 'is-disabled': disabled }"
      style="width: 100%!important;"
      popper-class="zwx-select-popper"
      v-model="value"
      placeholder="请选择"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      :filter-method="filtermethod"
      :disabled="disabled"
      @clear="cleardata"
      @remove-tag="removetag"
      @visible-change="visiblechange"
    >
      <!-- <el-option :value="selectDataList" style="height:auto!important;"> -->
      <template slot="empty">
        <!-- <div style="height:175px;min-width:160px;"> -->
        <zwx-scrollbar-y
          class="treescrollstyle"
          style="min-width: 160px; height: 175px;"
        >
          <el-tree
            class="zwx-tree"
            :ref="selecttreeref"
            :class="isshowparentcheckbox ? '' : 'hiddencheckbox'"
            :data="treeList"
            :node-key="nodekey"
            :props="defaultProps"
            :show-checkbox="showcheckbox"
            :accordion="accordion"
            :check-strictly="checkstrictly"
            :default-checked-keys="defaultcheckedkeys"
            :check-on-click-node="checkonclicknode"
            :filter-node-method="filternodemethod"
            @node-click="handleNodeClick"
            @check="checkbox"
          >
            <template slot-scope="{ node, data }">
              <div :class="{ optionstyle: data[isShowInputName] }">
                {{ data[defaultProps.label] }}
                <span @click="clickinput">
                  <el-input
                    v-if="data[isShowInputName]"
                    class="zwx-input"
                    style="width:calc(100% - 80px)!important;"
                    v-model="otherValue"
                    :maxlength="maxlength"
                    placeholder="请输入"
                    clearable
                    :disabled="data.disabled"
                  />
                </span>
              </div>
            </template>
          </el-tree>
        </zwx-scrollbar-y>
        <!-- </div> -->
      </template>
      <!-- </el-option> -->
    </el-select>
  </div>
</template>

<script>
export default {
  name: "TreeSelect",
  props: {
    innerWidth: {
      type: Number,
      default: null,
    },
    treeList: {
      type: Array,
      default: () => [],
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          label: "label",
        };
      },
    },
    // 父节点是否显示复选框
    isshowparentcheckbox: {
      type: Boolean,
      default: true,
    },
    // 是否开启手风琴模式
    accordion: {
      type: Boolean,
      default: true,
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否显示复选框
    showcheckbox: {
      type: Boolean,
      default: true,
    },
    checkonclicknode: {
      type: Boolean,
      default: true,
    },
    nodekey: {
      type: String,
      default: "rid",
    },
    // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法
    checkstrictly: {
      type: Boolean,
      default: false,
    },
    // checkstrictly为true时，选中子节点是否反选父节点
    ifReverseParent: {
      type: Boolean,
      default: false,
    },
    // checkstrictly,ifReverseParent为true时，当子节点只有一条数据时，选中父节点是否自动选中子节点
    ifSelectFirstChild: {
      type: Boolean,
      default: false,
    },
    defaultcheckedkeys: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    multipleOfTree: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    // 是否需要显示输入框的字段名
    isShowInputName: {
      type: String,
      default: "",
    },
    // 输入框绑定的字段名
    inputValueName: {
      type: String,
      default: "",
    },
    defaultOtherValue: {
      type: String,
      default: "",
    },
    maxlength: {
      type: Number,
      default: 10,
    },
    // checkstrictly,ifReverseParent为true时，选中父节点是否自动勾选子节点
    ifAutoSelectChild: {
      type: Boolean,
      default: true,
    },
  },
  // 定义属性
  data() {
    return {
      menuCode: "",
      api: this.$store.state.api,
      users: this.$store.state.users,
      value: [],
      selectDataList: [],
      selecttreeref: this.$system.uuid(),
      otherValue: "",
    };
  },
  // 方法集合
  methods: {
    clickinput(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    // 多选模式下移除tag时触发
    removetag(v) {
      this.selectDataList = [];
      this.$refs[this.selecttreeref].getCheckedNodes().forEach((obj) => {
        if (
          obj[this.defaultProps.children] == undefined &&
          obj[this.defaultProps.label] !== v
        ) {
          this.selectDataList.push(obj[this.nodekey]);
        }
      });
      this.$nextTick(() => {
        this.$refs[this.selecttreeref].setCheckedNodes(this.selectDataList);
        this.$emit(
          "selectDataList",
          this.selectDataList,
          this.$refs[this.selecttreeref].getCheckedNodes()
        );
      });
    },
    filtermethod(v) {
      this.$refs[this.selecttreeref].filter(v);
    },
    filternodemethod(v, data) {
      if (!v) return true;
      return data[this.defaultProps.label].indexOf(v) !== -1;
    },
    cleardata() {
      this.$refs[this.selecttreeref].setCheckedKeys([]);
      this.$emit("selectDataList", [], null);
      this.$emit("checkchange", []);
      this.$refs[this.selecttreeref].filter("");
    },
    // 点击节点事件
    handleNodeClick(data, node) {
      if (!this.multipleOfTree) {
        this.$refs[this.selecttreeref].setCheckedKeys([data[this.nodekey]]);
      }
    },
    // 选中复选框事件
    checkbox(a, b) {
      if (!this.multipleOfTree) {
        this.$refs[this.selecttreeref].setCheckedKeys([a[this.nodekey]]);
      }
      if (this.ifReverseParent) {
        this.setNode(this.$refs[this.selecttreeref].getNode(a[this.nodekey]));
      }
      // this.value = []
      // this.selectDataList = []
      // b.checkedNodes.forEach(obj => {
      //   if (!obj[this.defaultProps.children] || obj[this.defaultProps.children]?.length == 0) {
      //     this.value.push(obj[this.defaultProps.label])
      //     this.selectDataList.push(obj[this.nodekey])
      //   }
      // })
      this.$emit(
        "checkchange",
        this.$refs[this.selecttreeref].getCheckedNodes()
      );
    },
    visiblechange(bool) {
      if (!bool) {
        this.value = [];
        this.selectDataList = [];
        this.$refs[this.selecttreeref].getCheckedNodes().forEach((obj) => {
          if (this.checkstrictly) {
            this.value.push(obj[this.defaultProps.label]);
            this.selectDataList.push(obj[this.nodekey]);
          } else {
            if (
              obj[this.defaultProps.children] == undefined ||
              !obj[this.defaultProps.children]
            ) {
              if (obj[this.isShowInputName] && this.otherValue) {
                this.value.push(
                  obj[this.defaultProps.label] + "（" + this.otherValue + "）"
                );
              } else {
                this.value.push(obj[this.defaultProps.label]);
              }
              this.selectDataList.push(obj[this.nodekey]);
            }
          }
        });
        this.$emit(
          "selectDataList",
          this.selectDataList,
          this.$refs[this.selecttreeref].getCheckedNodes(),
          this.otherValue
        );
      } else {
        this.$refs[this.selecttreeref].filter();
      }
    },
    // 设置下拉框回显
    setCheckedKeys() {
      this.$nextTick(() => {
        const labellist = [];
        this.$refs[this.selecttreeref].getCheckedNodes()?.forEach((obj) => {
          if (this.checkstrictly) {
            labellist.push(obj[this.defaultProps.label]);
          } else {
            if (!obj[this.defaultProps.children]) {
              if (obj[this.isShowInputName] && this.otherValue) {
                labellist.push(
                  obj[this.defaultProps.label] + "（" + this.otherValue + "）"
                );
              } else {
                labellist.push(obj[this.defaultProps.label]);
              }
            }
          }
        });
        this.value = labellist;
      });
    },
    setNode(node) {
      if (node.checked) {
        //如果当前是选中checkbox,则递归设置父节点和父父节点++选中
        this.setParentNode(node);
        if (this.ifAutoSelectChild) {
          // 自动选中所有子节点
          this.setChildenNode(node, true);
        }
      } else {
        //当前是取消选中,将所有子节点都取消选中
        this.setChildenNode(node, false);
      }
    },
    setParentNode(node) {
      if (node.parent) {
        for (const key in node) {
          if (key === "parent") {
            node[key].checked = true;
            this.setParentNode(node[key]);
          }
        }
        if (node.childNodes.length == 1 && this.ifSelectFirstChild) {
          node.childNodes[0].checked = true;
        }
      }
    },
    setChildenNode(node, ifSelected) {
      let len = node.childNodes.length;
      for (let i = 0; i < len; i++) {
        node.childNodes[i].checked = ifSelected;
        this.setChildenNode(node.childNodes[i]);
      }
    },
  },
  components: {},
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {
    defaultcheckedkeys: {
      handler(v) {
        this.$refs[this.selecttreeref].setCheckedKeys(v);
        this.setCheckedKeys();
      },
    },
    defaultOtherValue: {
      handler(v) {
        this.otherValue = v;
        this.setCheckedKeys();
      },
      immediate: true,
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.setCheckedKeys();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" scoped>
.tree-select {
  width: 100%;
  /deep/input.el-input__inner {
    width: 100% !important;
  }
  /deep/span.el-tree-node__label {
    padding-right: 12px;
  }
  /deep/.el-tree.zwx-tree {
    height: 100% !important;
    // overflow-y: scroll;
  }
  /deep/.el-select__input {
    margin-left: 5px !important;
  }
  /deep/.el-select__tags-text {
    color: #1f2d3d !important;
  }
  /deep/.el-tree-node__content:has(.optionstyle) {
    height: 36px !important;
  }
}
.optionstyle {
  /deep/.el-icon-circle-close,
  /deep/.el-icon-circle-check {
    display: none !important;
  }
}
</style>

<style lang="less">
.el-tree.hiddencheckbox {
  // 不可全选样式
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block !important;
    }
    .el-checkbox .el-checkbox__inner {
      display: none !important;
    }
  }
}
</style>
